<template>
  <div id="title">
    <h1 :style="starBG">{{ val }}</h1>
  </div>
</template>

<script>
  export default {
    name: 'Title',
    props: [ 'val' ],

    data() {
      return {
        starBG: {
          backgroundImage: 'url(./img/fujiwara/title_stars.png), url(./img/fujiwara/title_stars.png)',
        }
      }
    }
  }
</script>

<style lang="scss" scoped>
  #title {
    h1 {
      background-color: $COLOR_PINK01;
      background-position: toVW(35) center, right toVW(35) center;
      background-size: toVW(145) auto, toVW(145) auto;
      background-repeat: no-repeat, no-repeat;
      border-top: $COLOR_PINK02 toVW(5) solid;
      border-bottom: $COLOR_PINK02 toVW(5) solid;
      font-size: toVW(40);
      line-height: toVW(64);
      text-align: center;
      margin-bottom: toVW(10);
    }
  }
</style>
